import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import RichText from '../../Core/RichText';
import TextWithIcon from '../TextWithIcon';

import { StyledContainer, Wrapper, Heading, Body } from './styles';

const ProTip = ({ data, className = '' }) => {
  if (!data) return null;

  const { proTipHeading, proTipBody, proTipIconDam } = data;

  return (
    <StyledContainer className={className}>
      <Wrapper className={proTipIconDam && proTipIconDam ? '' : 'no-icon'}>
        {proTipHeading &&
          (proTipIconDam ? (
            <TextWithIcon
              type="tip"
              icon={proTipIconDam.asset.localImage.publicURL}
            >
              <Heading>{ReactHtmlParser(proTipHeading)}</Heading>
            </TextWithIcon>
          ) : (
            <Heading>{ReactHtmlParser(proTipHeading)}</Heading>
          ))}
        {proTipBody && (
          <Body>
            <RichText document={proTipBody} />
          </Body>
        )}
      </Wrapper>
    </StyledContainer>
  );
};

ProTip.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default ProTip;
